import * as React from "react";
import { WizardCarPWAProps, WizardCarPWAState } from "./typings";
import { inject, observer } from "mobx-react";
import { WizardCarPWAView } from "./WizardCarPWAView";
import { Experiment, isVariantEnabled } from "../../utility/experiment";
import { carSubLOBs } from "src/stores/wizard/state/typings";

@inject("wizardState", "routeStore")
@observer
export class WizardCarPWA extends React.Component<WizardCarPWAProps, WizardCarPWAState> {
  constructor(props: WizardCarPWAProps) {
    super(props);
    this.state = {
      isDiffDropOff: false,
      isDriverAgeInRange: true,
      isAARPChecked: false,
    };

    const { carWizardState } = this.props.wizardState;
    carWizardState.overrideConfig(() => {
      carWizardState.config.elementId = this.props.flexComponent.id;
      carWizardState.config.heading.fixedTitle = this.props.flexComponent.model.fixedLobTitle;
      carWizardState.config.lastSearch.useLastSearchForSingleLOB = this.props.flexComponent.model.useLastSearchForSingleLOB;
      carWizardState.config.heading.lobSubtitleBreakPoint = this.props.flexComponent.model.lobSubtitleBreakPoint;
      carWizardState.config.heading.hideLobTitle = this.props.flexComponent.model.hideLobTitle;
      carWizardState.config.includeGT = this.props.flexComponent.model.includeGT ?? carWizardState.config.includeGT;
      const addGoogleFallback = (essFeatures: string): string => {
        if (
          isVariantEnabled(
            this.props.context,
            Experiment.Typeahead_Enabling_Google_Autocomplete_Suggestion_for_Car_Lob
          ) &&
          essFeatures.indexOf("google") < 0
        ) {
          essFeatures += "|google";
        }

        return essFeatures;
      };
      const essFeaturesDest = carWizardState.config.location.destination.essAdapterConfig.features;
      const essFeaturesOrigin = carWizardState.config.location.origin.essAdapterConfig.features;
      carWizardState.config.location.destination.essAdapterConfig.features = addGoogleFallback(essFeaturesDest);
      carWizardState.config.location.origin.essAdapterConfig.features = addGoogleFallback(essFeaturesOrigin);
    });
    carWizardState.updateStateFromCookie();
    carWizardState.updateDateFromConfig();
  }

  public componentDidMount() {
    const wizardCarState = this.props.wizardState.carWizardState;
    this.setState(() => ({
      isDiffDropOff: this.props.wizardState.carWizardState.isDifferentDropOff,
    }));
    wizardCarState.updateSubLOBState(carSubLOBs.rental);
  }

  private setSelectedTabOptions = (selectedTab: carSubLOBs) => {
    const wizardCarState = this.props.wizardState.carWizardState;
    wizardCarState.updateSubLOBState(selectedTab);
  };

  private toggleDifferentDropOff = () => {
    this.setState(({ isDiffDropOff }) => ({
      isDiffDropOff: !isDiffDropOff,
    }));
    this.props.wizardState.carWizardState.toggleIsDifferentDropOff();
  };

  private setIsDifferentDropOff = (differentDropOff: boolean) => {
    this.setState(() => ({
      isDiffDropOff: differentDropOff,
    }));
    this.props.wizardState.carWizardState.setIsDifferentDropoff(differentDropOff);
  };

  private toggleDriverAgeInRange = () => {
    this.setState(({ isDriverAgeInRange }) => ({
      isDriverAgeInRange: !isDriverAgeInRange,
    }));
  };

  private onAARPChange = () => {
    this.setState(({ isAARPChecked }) => ({
      isAARPChecked: !isAARPChecked,
    }));
  };

  private toggleBookRoundtrip = () => this.props.wizardState.carWizardState.toggleBookRoundtrip();

  public onTabOptionSelected = (selectedTab: carSubLOBs) => {
    this.setSelectedTabOptions(selectedTab);
  };

  public onDifferentDropOffSelected = () => this.toggleDifferentDropOff();

  public onDriverAgeInRange = () => this.toggleDriverAgeInRange();

  public render() {
    return (
      <WizardCarPWAView
        {...this.props}
        onTabOptionSelected={this.onTabOptionSelected}
        toggleBookRoundtrip={this.toggleBookRoundtrip}
        onDifferentDropOffSelected={this.onDifferentDropOffSelected}
        setIsDifferentDropOff={this.setIsDifferentDropOff}
        onDriverAgeInRange={this.onDriverAgeInRange}
        onAARPChange={this.onAARPChange}
        isDiffDropOff={this.state.isDiffDropOff}
        isDriverAgeInRange={this.state.isDriverAgeInRange}
        isAARPChecked={this.state.isAARPChecked}
        selectedTab={this.props.wizardState.carWizardState.subLOBState}
      />
    );
  }
}

export default WizardCarPWA;
